import { ApplicationState } from '@app/store'
import {
  ICurrentUserState,
  selectCurrentUser,
} from '@app/store/modules/account'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import FeedItem, {
  IFeedItemModuleProps,
  IFeedItemUIProps,
} from '../components/FeedItem'
import { actionCreators, selectFeedItem } from '../modules/feedItems'

type FeedItemProps = IFeedItemModuleProps & ICurrentUserState

export default connect(
  (state: ApplicationState, ownProps: IFeedItemUIProps) =>
    createStructuredSelector<ApplicationState, FeedItemProps>({
      item: selectFeedItem(ownProps.feedItemId),
      user: selectCurrentUser(),
    }),
  actionCreators,
)(FeedItem)
